var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('growth-search',{on:{"doSearch":_vm.doSearch,"export":_vm.exportData}}),_c('growth-list',{attrs:{"search-condition":_vm.searchCondition,"is-export":_vm.isExport}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }